var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProblemSolving(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 179,
    viewBox: "0 0 138 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7504 63.0004C40.7075 60.0667 42.3786 57.3785 45.0274 56.1177C47.6761 54.8577 50.8166 55.2577 53.0654 57.1408C55.3142 59.0248 56.2583 62.046 55.4824 64.875H65.1255V55.2319C62.0742 56.0705 58.8246 54.9032 57.0033 52.3154C55.1828 49.7267 55.1828 46.2738 57.0033 43.6851C58.8246 41.0965 62.0742 39.9292 65.1255 40.7686V33.2327C58.604 33.9742 52.4775 36.738 47.6057 41.1359C40.8629 47.1861 37.0082 55.8156 37.0005 64.875H41.0182C40.85 64.2639 40.7599 63.6339 40.7504 63.0004Z",
    fill: "url(#paint0_radial_16_359)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4998 47.9998C59.4998 50.0708 61.1786 51.7497 63.2497 51.7497C64.1707 51.7506 65.059 51.4089 65.7422 50.7918C65.8135 50.7412 65.8898 50.6957 65.9688 50.6571C66.0804 50.5712 66.2023 50.4991 66.331 50.4416C66.4598 50.4004 66.5928 50.373 66.7284 50.361C66.8177 50.3361 66.9078 50.3172 66.9996 50.306H67.0468C67.1867 50.3189 67.3241 50.3464 67.4571 50.3884C67.5601 50.4056 67.6605 50.4305 67.7592 50.464C67.8459 50.512 67.9275 50.5669 68.0047 50.6287C68.1309 50.7008 68.2485 50.7875 68.354 50.8871C68.3652 50.8991 68.3798 50.9025 68.3892 50.9137C68.4407 50.9867 68.4862 51.063 68.5266 51.1429C68.6115 51.2536 68.6828 51.3746 68.7403 51.5025C68.7823 51.6321 68.8089 51.766 68.821 51.9016C68.8458 51.9935 68.8639 52.087 68.875 52.1814V64.8749H81.5685C81.6586 64.8852 81.747 64.9041 81.8329 64.929C81.9711 64.9401 82.1067 64.9667 82.238 65.0097C82.365 65.068 82.4852 65.1393 82.5959 65.2234C82.6757 65.2637 82.7521 65.3092 82.8251 65.3607C82.838 65.3607 82.8422 65.3847 82.8534 65.3959C82.9538 65.504 83.0422 65.6242 83.116 65.7521C83.1744 65.8276 83.2276 65.9075 83.2748 65.9907C83.3092 66.0911 83.3349 66.195 83.3521 66.2997C83.3941 66.4319 83.4216 66.5675 83.4345 66.7048C83.4345 66.7203 83.4439 66.7331 83.4439 66.7503C83.4328 66.8413 83.4139 66.9314 83.3873 67.0198C83.377 67.1554 83.3495 67.2902 83.3066 67.4189C83.2508 67.5477 83.1787 67.6687 83.0929 67.7794C83.0534 67.8584 83.0088 67.9348 82.9581 68.0077C82.341 68.6909 81.9994 69.5793 82.0002 70.5002C82.0002 72.5713 83.6791 74.2502 85.7502 74.2502C87.8213 74.2502 89.5001 72.5713 89.5001 70.5002C89.501 69.5793 89.1594 68.6909 88.5423 68.0077C88.4908 67.9356 88.4461 67.8592 88.4066 67.7794C88.3217 67.6678 88.2504 67.5477 88.1929 67.4189C88.15 67.2902 88.1234 67.1554 88.1122 67.0198C88.0865 66.9314 88.0676 66.8413 88.0565 66.7503C88.0565 66.7331 88.0659 66.7203 88.0659 66.7048C88.0779 66.5666 88.1054 66.4302 88.1483 66.298C88.1646 66.1933 88.1903 66.0903 88.2247 65.9907C88.2719 65.9066 88.326 65.8259 88.386 65.7504C88.4581 65.6225 88.5457 65.5032 88.647 65.3959C88.6581 65.3847 88.6616 65.3702 88.6753 65.3607C88.9465 65.1067 89.2967 64.9547 89.6666 64.929C89.7533 64.9041 89.8417 64.8852 89.931 64.8749H100.75C100.75 63.6158 100.678 62.3575 100.535 61.1061C98.7638 46.4325 87.1587 34.8891 72.4748 33.1966C71.2791 33.0669 70.0775 33.0017 68.875 33V43.8189C68.8639 43.9099 68.8458 44 68.821 44.0885C68.8089 44.2241 68.7823 44.3588 68.7403 44.4884C68.6828 44.6163 68.6115 44.7365 68.5266 44.8481C68.4862 44.9279 68.4407 45.0043 68.3892 45.0772C68.3892 45.0884 68.3652 45.0918 68.354 45.103C68.2468 45.2034 68.1283 45.2909 68.0013 45.3639C67.9249 45.424 67.8442 45.4781 67.7592 45.527C67.6597 45.5596 67.5575 45.5845 67.4537 45.6016C67.3215 45.6446 67.185 45.6729 67.0468 45.684C67.0297 45.684 67.0168 45.684 66.9996 45.684C66.9087 45.6729 66.8185 45.6549 66.7301 45.63C66.5945 45.6171 66.4606 45.5905 66.331 45.5493C66.2031 45.4918 66.0821 45.4197 65.9705 45.3356C65.8916 45.2952 65.8152 45.2497 65.7422 45.1991C65.0573 44.5846 64.1698 44.2464 63.2497 44.2498C61.1786 44.2498 59.4998 45.9287 59.4998 47.9998V47.9998Z",
    fill: "url(#paint1_linear_16_359)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.7503 113.625H52C50.9649 113.625 50.1255 114.464 50.1255 115.5C50.1255 116.536 50.9649 117.375 52 117.375H85.7503C86.7854 117.375 87.6249 116.536 87.6249 115.5C87.6249 114.464 86.7854 113.625 85.7503 113.625V113.625Z",
    fill: "url(#paint2_radial_16_359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8752 138C74.3624 137.993 79.047 134.035 79.9697 128.625H57.7808C58.7034 134.035 63.3881 137.993 68.8752 138V138Z",
    fill: "url(#paint3_radial_16_359)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_16_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8752 68.6248V80.5741C71.6862 79.842 74.6671 80.8015 76.5228 83.0366C78.3784 85.2716 78.7741 88.3778 77.5373 91.0068C76.3004 93.6349 73.6551 95.3112 70.7506 95.3061C70.1164 95.2975 69.4864 95.2073 68.8752 95.0383V109.875H82.0005V108.42C81.9962 100.722 85.1556 93.3611 90.738 88.0611C96.2028 82.9473 99.6747 76.0594 100.535 68.6248H92.9825C93.821 71.676 92.6538 74.9264 90.0651 76.7469C87.4765 78.5674 84.0235 78.5674 81.4357 76.7469C78.847 74.9264 77.6797 71.676 78.5183 68.6248H68.8752Z",
    fill: "url(#paint4_linear_16_359)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.7503 124.875C86.7854 124.875 87.6249 124.035 87.6249 123C87.6249 121.964 86.7854 121.125 85.7503 121.125H52C50.9649 121.125 50.1255 121.964 50.1255 123C50.1255 124.035 50.9649 124.875 52 124.875H85.7503Z",
    fill: "url(#paint5_radial_16_359)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_16_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.852 67.2C45.8357 67.3047 45.81 67.4086 45.7756 67.509C45.7284 67.5922 45.6743 67.6721 45.616 67.7476C45.5422 67.8755 45.4546 67.9956 45.3533 68.1038C45.3422 68.115 45.3387 68.1295 45.325 68.139C45.2529 68.1905 45.1774 68.236 45.0984 68.2763C44.9868 68.3604 44.8658 68.4325 44.7388 68.49C44.6083 68.5304 44.4744 68.5578 44.3388 68.5707C44.2504 68.5956 44.1603 68.6136 44.0693 68.6248H37.2346C38.0826 76.062 41.551 82.9542 47.0184 88.0671C52.5992 93.3646 55.7569 100.725 55.75 108.42V109.875H65.1253V91.987C65.1364 91.9003 65.1536 91.8136 65.1776 91.7287C65.1888 91.5888 65.2171 91.4497 65.26 91.3158C65.3158 91.1922 65.3862 91.0755 65.4686 90.9673C65.5089 90.8832 65.5561 90.8026 65.6111 90.727C65.6222 90.7159 65.6368 90.7124 65.648 90.6996C65.7493 90.606 65.8608 90.5245 65.9801 90.4558C66.0625 90.388 66.1509 90.3279 66.2445 90.2773C66.3355 90.2472 66.4282 90.2241 66.5217 90.2077C66.6634 90.1623 66.8093 90.1331 66.9569 90.1219C66.9715 90.1176 66.9861 90.1142 66.9998 90.1125C67.0891 90.1228 67.1766 90.1408 67.2625 90.1648C67.4015 90.1777 67.5388 90.2052 67.6719 90.2472C67.7955 90.3039 67.913 90.3743 68.0221 90.4558C68.1053 90.497 68.1843 90.5442 68.2598 90.5983C68.9422 91.2163 69.8296 91.5579 70.7506 91.5561C72.8217 91.5561 74.5005 89.8773 74.5005 87.8062C74.5005 85.7351 72.8217 84.0563 70.7506 84.0563C69.8296 84.0554 68.9413 84.397 68.2581 85.0141C68.1851 85.0648 68.1087 85.1111 68.0298 85.1515C67.9191 85.2364 67.7989 85.3077 67.6719 85.3652C67.4478 85.4098 67.2238 85.4545 66.9998 85.4999C66.9835 85.4999 66.9706 85.4999 66.9552 85.4999C66.8178 85.4879 66.6822 85.4605 66.5501 85.4193C66.4453 85.4021 66.3415 85.3763 66.2411 85.342C66.1587 85.2948 66.0797 85.2416 66.0042 85.1832C65.8754 85.1094 65.7544 85.021 65.6463 84.9189C65.6351 84.9077 65.6205 84.9034 65.6111 84.8923C65.5596 84.8193 65.5141 84.7429 65.4737 84.664C65.2926 84.4511 65.1888 84.1833 65.1793 83.9044C65.1545 83.8125 65.1364 83.719 65.1253 83.6245V68.6248H52.4318C52.1932 68.6231 51.958 68.575 51.7374 68.484C51.6421 68.4377 51.5512 68.3819 51.4662 68.3175C51.3632 68.2686 51.2653 68.2085 51.1752 68.139C51.1623 68.139 51.1581 68.115 51.1469 68.1038C51.0465 67.9965 50.9589 67.8772 50.8868 67.7493C50.8268 67.6738 50.7727 67.5931 50.7255 67.509C50.6911 67.4094 50.6654 67.3064 50.6482 67.2017C50.6062 67.0695 50.5787 66.9331 50.5658 66.7949C50.5658 66.7803 50.5658 66.7666 50.5658 66.7502C50.577 66.6584 50.5959 66.5683 50.6225 66.4799C50.6328 66.3443 50.6602 66.2095 50.7032 66.0808C50.7598 65.9529 50.831 65.8319 50.9169 65.7203C50.9555 65.6405 51.0001 65.5641 51.0516 65.492C51.6653 64.807 52.0035 63.9196 52.0001 63.0003C52.0001 60.9292 50.3212 59.2495 48.2501 59.2495C46.179 59.2495 44.5002 60.9292 44.5002 63.0003C44.4993 63.9204 44.8409 64.8088 45.458 65.492C45.5087 65.5649 45.5542 65.6413 45.5937 65.7203C45.6786 65.8319 45.7507 65.952 45.8074 66.0808C45.8503 66.2095 45.8769 66.3443 45.8881 66.4799C45.9138 66.5683 45.9327 66.6584 45.9438 66.7502V66.7949C45.9284 66.9331 45.8975 67.0687 45.852 67.2V67.2Z",
    fill: "url(#paint6_linear_16_359)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_359",
    x: 0.415157,
    y: 0.0732017,
    width: 136.92,
    height: 178.171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.65853
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.2927
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_359",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16_359",
    x: 55.4998,
    y: 33,
    width: 49.2502,
    height: 49.2502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_359",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_16_359",
    x: 64.8752,
    y: 68.6248,
    width: 39.6594,
    height: 49.2502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_359",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_16_359",
    x: 33.2346,
    y: 59.2495,
    width: 45.2659,
    height: 58.6255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_359",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16_359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9602 36.553) rotate(90) scale(38.0051 33.7804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_359",
    x1: 51.5033,
    y1: 33.0591,
    x2: 89.076,
    y2: 63.2295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBFD5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#7FBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_16_359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0715 114.018) rotate(90) scale(4.50399 45.0399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_16_359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.2162 129.609) rotate(90) scale(11.2605 26.6508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16_359",
    x1: 62.7379,
    y1: 68.6839,
    x2: 97.1127,
    y2: 89.8688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#F25123"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_16_359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0715 121.518) rotate(90) scale(4.50399 45.0399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16_359",
    x1: 30.0105,
    y1: 59.3221,
    x2: 71.3851,
    y2: 83.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#02A3F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblemSolving);
export default __webpack_public_path__ + "static/media/ProblemSolving.387cab72daf3565b257041aeeb2e5807.svg";
export { ForwardRef as ReactComponent };